import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      t="1637286297960"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2118"
      width="32"
      height="32"
    >
      <path
        d="M855.68 312.32h-55.68V288C800 129.28 670.72 0 512 0S224 129.28 224 288v23.68h-55.68C110.72 312.32 64 358.4 64 416v503.68c0 57.6 46.72 104.32 104.32 104.32h688c57.6 0 104.32-46.72 104.32-104.32V416c-0.64-57.6-47.36-103.68-104.96-103.68zM288 288C288 164.48 388.48 64 512 64s224 100.48 224 224v23.68h-448V288z m608 631.68c0 22.4-17.92 40.32-40.32 40.32H168.32c-22.4 0-40.32-17.92-40.32-40.32V416c0-22.4 17.92-40.32 40.32-40.32h688c21.76 0.64 39.68 18.56 39.68 40.32v503.68z',
        'M512 544c-17.92 0-32 14.08-32 32v128c0 17.92 14.08 32 32 32s32-14.08 32-32V576c0-17.92-14.08-32-32-32z"
        fill="#8a8a8a"
        p-id="2119"
      />
    </svg>
  )
}
const PasswordIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
PasswordIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#fff',
}
// 参数类型
PasswordIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default PasswordIcon
